import { css, html, nothing } from "lit";
import WarpElement from "@warp-ds/elements-core";
import { Brand, Subvertical } from "../../constants.js";

class ShowDeprecationNotice extends WarpElement {
    declare subvertical: Subvertical;
    declare brand: Brand;
    declare showDeprecationMessage: boolean;
    declare hidden: boolean;

    static properties = {
        subvertical: { type: Subvertical },
        brand: { type: String },

        hideDeprecationMessage: { type: Boolean },
    };

    static styles = [
        WarpElement.styles,
        css`
            @css-placeholder-lEMC0j;
        `,
    ];

    constructor() {
        super();
        this.showDeprecationMessage = true;
        this.hidden = true;
    }

    async connectedCallback() {
        super.connectedCallback();
        this.updateDeprecationMessage();
    }

    updateDeprecationMessage() {
        const isDba = this.brand === Brand.DBA;
        this.showDeprecationMessage = isDba
            ? typeof localStorage !== "undefined" && localStorage.getItem("hideDeprecationMessage") !== "true"
            : false;
        this.hidden = !this.showDeprecationMessage;
    }

    handleShowDeprecationMessage() {
        localStorage.setItem("hideDeprecationMessage", "true");
        this.showDeprecationMessage = true;
        this.hidden = true;
    }

    getDeprecationMessage() {
        switch (this.subvertical) {
            case Subvertical.Boat:
                return html`<strong>Bemærk:</strong> Bådpladser er midlertidigt ikke tilgængelige på DBA. Vi arbejder på at få dem tilbage
                    snarest.`;
            // case Subvertical.B2B:
            //     return html`<strong>Bemærk:</strong> Entreprenørmaskiner, lastbiler og busser er midlertidigt ikke tilgængelige på DBA. Vi
            //         arbejder på at få dem tilbage snarest.`;
            // case Subvertical.Car:
            //     return html`<strong>Bemærk:</strong> Lastbiler og busser er midlertidigt ikke tilgængelige på DBA. Vi arbejder på at få dem
            //         tilbage snarest.`;
            default:
                return undefined;
        }
    }

    render() {
        const deprecationMessage = this.getDeprecationMessage();
        if (this.showDeprecationMessage && deprecationMessage) {
            return html`<div class="s-bg-info-subtle mt-16 p-16" style="margin-bottom: 40px;">
                <div class="flex justify-between items-center gap-8">
                    <div class="flex items-center gap-x-16 w-full">
                        <w-icon-info-24 class="flex items-center s-icon-primary"></w-icon-info-24>
                        <p class="mb-0">${deprecationMessage}</p>
                    </div>
                    <button class="bg-transparent" @click=${this.handleShowDeprecationMessage}>
                        <w-icon-close-24 class="flex items-center s-icon-primary"></w-icon-close-24>
                    </button>
                </div>
            </div>`;
        }

        return nothing;
    }
}

customElements.define("show-deprecation-notice", ShowDeprecationNotice as unknown as CustomElementConstructor);
